import { render, staticRenderFns } from "./advertising-edit.vue?vue&type=template&id=bb56199c&scoped=true"
import script from "./advertising-edit.vue?vue&type=script&lang=js"
export * from "./advertising-edit.vue?vue&type=script&lang=js"
import style0 from "./advertising-edit.vue?vue&type=style&index=0&id=bb56199c&prod&lang=scss&scoped=true"
import style1 from "./advertising-edit.vue?vue&type=style&index=1&id=bb56199c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb56199c",
  null
  
)

export default component.exports